import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.profile.profile;

export const profileEditMode = createSelector([baseState], (state) => {
   return state.isEdit;
});